import type { PropsWithChildren } from "react"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"

const VidmaxDndProvider = (p: PropsWithChildren) => {
  return <DndProvider backend={HTML5Backend}>{p.children}</DndProvider>
}

export default VidmaxDndProvider
